import { IDeviceLocation, IOrganizationTag } from '../../FrontApplet/DeviceInfo/IDeviceInfo';

export type DeviceInfoRequests = DeviceInfoGetLocationRequest | DeviceInfoGetOrganizationTagsRequest | DeviceInfoGetDeviceNameRequest;

export const DeviceInfoGetLocationRequest = 'sos.Monitoring.DeviceInfo.GetLocationRequest';
export interface DeviceInfoGetLocationRequest {
	type: typeof DeviceInfoGetLocationRequest;
}

export const DeviceInfoGetLocationResult = 'sos.Monitoring.DeviceInfo.GetLocationResult';
export interface DeviceInfoGetLocationResult {
	type: typeof DeviceInfoGetLocationResult;
	result: IDeviceLocation | null;
}

export const DeviceInfoGetOrganizationTagsRequest = 'sos.Monitoring.DeviceInfo.GetOrganizationTagsRequest';
export interface DeviceInfoGetOrganizationTagsRequest {
	type: typeof DeviceInfoGetOrganizationTagsRequest;
}

export const DeviceInfoGetOrganizationTagsResult = 'sos.Monitoring.DeviceInfo.GetOrganizationTagsResult';
export interface DeviceInfoGetOrganizationTagsResult {
	type: typeof DeviceInfoGetOrganizationTagsResult;
	result: IOrganizationTag[];
}

export const DeviceInfoGetDeviceNameRequest = 'sos.Monitoring.DeviceInfo.GetNameRequest';
export interface DeviceInfoGetDeviceNameRequest {
	type: typeof DeviceInfoGetDeviceNameRequest;
}

export const DeviceInfoGetDeviceNameResult = 'sos.Monitoring.DeviceInfo.GetNameResult';
export interface DeviceInfoGetDeviceNameResult {
	type: typeof DeviceInfoGetDeviceNameResult;
	result: string | null;
}
